import { fromClass, fromClassArray } from "fw-model";
import { SearchResult } from "./search-result";
import { SelectionItem } from "./definitions";

export enum AutomationRuleExecutionStatus {
    Requested = 0,
    Running = 1,
    Complete = 2,
    Error = 3
}

export type Filter = {
    organization?: string;
    status?: number;
    ruleId?: string;
    range?: string | [];
    missing?: string;
};

export type HeadersType = {
    label: string;
    sort?: string;
    key?: string;
    class?: string;
};

export type SortParamsType = {
    column: string;
    order: "asc" | "desc";
};

export type Flag = {
    open: boolean;
};

export type TabsType = {
    label: string;
    value: number;
};

export class AtsAutomationRuleTaskSearchResult extends SearchResult<AtsAutomationRuleExecutionInfo> {}

export class AtsAutomationRuleExecutionMetaData {
    OrganizationId: string;
    SeasonId: string;
    RuleId: string;
    DateCreatedUtc: Date;
    DateUpdatedUtc: Date;
}

export class AtsAutomatedAction {
    Type: string;
}
export class AtsActionSetExecution {
    Filter: string;
    TotalApplicationCount: number;
    CompletedApplicationCount: number;
    Status: AutomationRuleExecutionStatus;
    @fromClassArray(AtsAutomatedAction) Actions: AtsAutomatedAction[];
}
export class AtsAutomationRuleExecution {
    Id: string;
    Name: string;
    TotalApplicationCount: number;
    RunDateUtc: Date;
    Status: AutomationRuleExecutionStatus;
    @fromClass MetaData: AtsAutomationRuleExecutionMetaData;
    @fromClassArray(AtsActionSetExecution) ActionSets: AtsActionSetExecution[];
}
export class AtsAutomationRuleExecutionInfo {
    @fromClass Execution: AtsAutomationRuleExecution;
    OrganizationId: string;
    OrganizationName: string;
    AutomationRuleId: string;
    AutomationRuleName: string;
}

export const AUTOMATION_RULE_STATUSES: SelectionItem[] = [
    { label: "All Statuses", value: null },
    { label: "Requested", value: AutomationRuleExecutionStatus.Requested, color: "pending-color" },
    { label: "Running", value: AutomationRuleExecutionStatus.Running, color: "pending-color" },
    { label: "Complete", value: AutomationRuleExecutionStatus.Complete, color: "complete-color" },
    { label: "Error", value: AutomationRuleExecutionStatus.Error, color: "error-color", styleColor: "#7f1d1d" }
];

export function getStatusName(index): string {
    return AUTOMATION_RULE_STATUSES.find((item) => item.value === index)?.label;
}

export function getStatusColor(index): string {
    return AUTOMATION_RULE_STATUSES.find((item) => item.value === index)?.color ?? "pending-color";
}
